<template>
  <div style="position: relative">
    <div class="block">
      <el-row :gutter="5">
        <el-col :span="18">
          <h1>完整项目</h1>
          <el-timeline>
            <el-timeline-item v-for="project of projects" :key="project.id " placement="top">
              <el-card>
                <el-row :gutter="6">
                  <a :href="project.path" style="text-decoration: white;color: black">
                    <el-col :span="12">
                      <div class="image">
                        <img :src="project.image" width="360" height="220" class="images">
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content bg-purple">
                        <h2 style="margin-bottom: 10px">{{ project.name }}</h2>
                        <p style="line-height: 22px">{{ project.description }}</p>
                        <h4>{{ project.techs }}</h4>
                      </div>
                    </el-col>
                  </a>
                </el-row>
              </el-card>
            </el-timeline-item>

          </el-timeline>

        </el-col>
      </el-row>

      <div class="prac-info">
        <h1>小练习</h1>
        <el-row class="demo-container" :gutter="3">
          <div class="prac-bigdiv">
            <el-col :xs="24" :sm="10" :lg="6" v-for="practice of practice" :key="practice.id" class="el_practice">
              <div class="div_dh">
                <img :src="practice.image" width="200" height="200px" class="div_img">
                <a :href="practice.path" style="text-decoration: none">
                  <div class="div_text" style="padding-left: 4px">
                    <h3>{{ practice.name }}</h3>
                    <p style="width: 100%">{{ practice.techs }}</p>
                  </div>
                </a>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
    </div>


  </div>

</template>

<script>

import request from "../utils/axiosUtils";
import base_url from "../utils/Constants";

export default {
  name: "Project",
  data() {
    return {
      projects: [
        {},
      ],
      practice: [
        {},
      ]
    }

  },
  methods: {
    getProject() {
      request({
        url: '/project/get',
        method: 'get',
      }).then(response => {
        this.practice = [];
        this.projects = [];
        for (let i = 0; i < response.data.data.length; i++) {
          let datum = response.data.data[i];
          datum.image = base_url + "/getImage/" + datum.image
          if (datum.projectCategoryId === 1) {
            this.projects.push(datum)
          } else {
            this.practice.push(datum)
          }
        }

      })

    },
  },
  mounted() {
    this.getProject();
  }
}
</script>
<style>
.el-card__body {
  padding: 0px;
}
</style>
<style scoped>
h1 {
  color: white;
  background: rgba(0, 0, 0, 0.15);
  width: 1000px;
}

.h2 {
  font-size: large;
}

.block {
  width: 1200px;
  margin: 0 auto;
  padding-left: 120px;
}

.image {
  width: 360px;
  height: 220px;
  border: 0px;
  overflow: hidden;
}

.images {
  cursor: pointer;
  transition: all 0.6s;
}

.images:hover {
  transform: scale(1.4);
}

.div_dh {
  width: 200px;
  height: 200px;
  margin: 20px auto;
  overflow: hidden;
}

.div_dh:hover a .div_text {
  top: -200px;
}

.div_text {
  width: 200px;
  height: 200px;
  background: rgba(52, 61, 61, 0.6);
  position: relative;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  overflow: hidden;
  top: -50px;
  color: white;
}


.prac-bigdiv {
  width: 1000px;
}

.el-timeline {
  margin: 30px;

}

.el-row {

  margin-bottom: 0;

}

.el-col {
  border-radius: 0;
}

.bg-purple-dark {
  background: white;
}

.bg-purple {
  background: white;
}

.bg-purple-light {
  background: white;
}

.grid-content {
  border-radius: 0;
  min-height: 0;
  width: 350px;
  height: 203px;
}

.row-bg {
  padding: 0 0;
  background-color: white;
}

p {
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  height: 110px;
  overflow: hidden;
}


</style>



// WEBPACK FOOTER //
// src/components/Project.vue